export class Size {
  constructor(pixelValue) {
    this.pixelValue = pixelValue;
  }
  value() {
    return this.pixelValue;
  }
  addPixels(pixels) {
    return new Size(this.pixelValue + pixels);
  }
  multiply(factor) {
    return new Size(this.pixelValue * factor);
  }
}
//# sourceMappingURL=Size.js.map